import { useDispatch } from 'react-redux'

import { removeBrochure } from '@store/actionSlices/brochure'
import { resetBuilding } from '@store/actionSlices/building'
import { removeDesign } from '@store/actionSlices/design'
import { removeExternalViews } from '@store/actionSlices/externalViews'
import { removeFloorPlateGallery } from '@store/actionSlices/floorPlateGallery'
import { removeInteractiveMap } from '@store/actionSlices/interactiveMap'
import { removeInteractivePlan } from '@store/actionSlices/interactivePlan'
import { removeLocation } from '@store/actionSlices/location'
import { removeFilter as removeLotFilter } from '@store/actionSlices/lotFilter'
import { removePanoramicData } from '@store/actionSlices/panoramic'
import { removeProjectConfig } from '@store/actionSlices/projectConfig'
import { removeShortlist } from '@store/actionSlices/shortlist'
import { removeTeams } from '@store/actionSlices/teams'
import { removeFilter } from '@store/actionSlices/unitFilter'
import { removeUnitGallery } from '@store/actionSlices/unitGallery'
import { removeVideoGallery } from '@store/actionSlices/videoGallery'
import { resetVision } from '@store/actionSlices/vision'
import { removeWhiteLabel } from '@store/actionSlices/whiteLabel'

import { agentApi } from '@api/agent'
import { userApi } from '@api/authentication'
import { brochureApi } from '@api/brochure'
import { buildingApi } from '@api/building'
import { clearCacheApi } from '@api/clear-cache'
import { configApi } from '@api/config'
import { designApi } from '@api/design'
import { externalLinksApi } from '@api/external-links'
import { externalViewsApi } from '@api/external-views'
import { floorPlateGalleryApi } from '@api/floor-plate-gallery'
import { houseAndLandApi } from '@api/houseAndLand'
import { interactiveMapApi } from '@api/interactive-map'
import { interactivePlanApi } from '@api/interactive-plan'
import { locationApi } from '@api/location'
import { masterKeyApi } from '@api/master-key'
import { panoramicApi } from '@api/panoramic'
import { projectListApi } from '@api/project-list'
import { shortlistApi } from '@api/shortlist'
import { showcaseRoomApi } from '@api/showcase-room'
import { teamsApi } from '@api/teams'
import { unitGalleryApi } from '@api/unit-gallery'
import { videoGalleryApi } from '@api/video-gallery'
import { visionApi } from '@api/vision'
import { whiteLabelApi } from '@api/white-label'

const ResetUtil = () => {
  const dispatch = useDispatch()

  const resetStore = () => {
    dispatch(removeProjectConfig())
    dispatch(resetBuilding())
    dispatch(removeDesign())
    dispatch(removeInteractivePlan())
    dispatch(removeLocation())
    dispatch(removeShortlist())
    dispatch(removeTeams())
    dispatch(removeFilter())
    dispatch(removeLotFilter())
    dispatch(resetVision())
    dispatch(removeBrochure())
    dispatch(removePanoramicData())
    dispatch(removeVideoGallery())
    dispatch(removeFloorPlateGallery())
    dispatch(removeExternalViews())
    dispatch(removeUnitGallery())
    dispatch(removeInteractiveMap())
    dispatch(removeWhiteLabel())
  }

  const resetApiState = () => {
    dispatch(configApi.util.resetApiState())
    dispatch(buildingApi.util.resetApiState())
    dispatch(designApi.util.resetApiState())
    dispatch(interactivePlanApi.util.resetApiState())
    dispatch(locationApi.util.resetApiState())
    dispatch(teamsApi.util.resetApiState())
    dispatch(visionApi.util.resetApiState())
    dispatch(brochureApi.util.resetApiState())
    dispatch(panoramicApi.util.resetApiState())
    dispatch(videoGalleryApi.util.resetApiState())
    dispatch(externalViewsApi.util.resetApiState())
    dispatch(floorPlateGalleryApi.util.resetApiState())
    dispatch(unitGalleryApi.util.resetApiState())
    dispatch(interactiveMapApi.util.resetApiState())
    dispatch(whiteLabelApi.util.resetApiState())
  }

  const resetAllApiState = () => {
    dispatch(agentApi.util.resetApiState())
    dispatch(userApi.util.resetApiState())
    dispatch(brochureApi.util.resetApiState())
    dispatch(buildingApi.util.resetApiState())
    dispatch(clearCacheApi.util.resetApiState())
    dispatch(configApi.util.resetApiState())
    dispatch(designApi.util.resetApiState())
    dispatch(externalLinksApi.util.resetApiState())
    dispatch(externalViewsApi.util.resetApiState())
    dispatch(floorPlateGalleryApi.util.resetApiState())
    dispatch(houseAndLandApi.util.resetApiState())
    dispatch(interactiveMapApi.util.resetApiState())
    dispatch(interactivePlanApi.util.resetApiState())
    dispatch(locationApi.util.resetApiState())
    dispatch(masterKeyApi.util.resetApiState())
    dispatch(panoramicApi.util.resetApiState())
    dispatch(projectListApi.util.resetApiState())
    dispatch(shortlistApi.util.resetApiState())
    dispatch(showcaseRoomApi.util.resetApiState())
    dispatch(teamsApi.util.resetApiState())
    dispatch(unitGalleryApi.util.resetApiState())
    dispatch(videoGalleryApi.util.resetApiState())
    dispatch(visionApi.util.resetApiState())
    dispatch(whiteLabelApi.util.resetApiState())
  }

  const resetLocalStorage = () => {
    localStorage.removeItem('buildingApiData')
    localStorage.removeItem('configApiData')
    localStorage.removeItem('designApiData')
    localStorage.removeItem('interactivePlanApiData')
    localStorage.removeItem('interactiveMapData')
    localStorage.removeItem('locationApiData')
    localStorage.removeItem('teamsApiData')
    localStorage.removeItem('visionApiData')
    localStorage.removeItem('brochureApiData')
    localStorage.removeItem('bedConfigApiData')
    localStorage.removeItem('panoramicApiData')
    localStorage.removeItem('videoGalleryApiData')
    localStorage.removeItem('floorPlateGalleryApiData')
    localStorage.removeItem('externalViewsData')
    localStorage.removeItem('buildingPageConfig')
    localStorage.removeItem('unitGalleryApiData')
    localStorage.removeItem('projectConfig')
    localStorage.removeItem('theme')
    localStorage.removeItem('themeObject')
    localStorage.removeItem('houseAndLandApiData')
    localStorage.removeItem('houseAndLandActiveData')
    localStorage.removeItem('shortlist')
    localStorage.removeItem('shortlistPropertyHash')
    localStorage.removeItem('whiteLabelApiData')
  }

  return {
    resetStore,
    resetApiState,
    resetAllApiState,
    resetLocalStorage,
  }
}

export default ResetUtil
